import React from 'react';
import { RecoilRoot } from 'recoil';
import Routes from './routes';
import { I18nextProvider } from 'react-i18next'
import i18n from './utils/i18n'

import { DatePickerProvider } from './providers/DatePickerProvider';
import { ConfigProvider } from 'antd';
import ptBr from 'antd/lib/locale/pt_BR';

function App() {
  return (
    <RecoilRoot>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider locale={ptBr}>
          <DatePickerProvider>
            <div className="data-finder-app">
              <Routes />
            </div>
          </DatePickerProvider>
        </ConfigProvider>
      </I18nextProvider>
    </RecoilRoot>
  );
}

export default App;
